export function useFilterHelper() {
    
    const generate = (pageSearchQuery, sort, sortDir, filters = []) => {
        var queryParams = {};

        if (pageSearchQuery.value) {
            queryParams["filter"] = pageSearchQuery.value;
        } else {
            if (queryParams.filter) delete queryParams.filter;
        }
        if (sort.value) {
            queryParams["sort"] = sort.value;
        } else {
            if (queryParams.sort) delete queryParams.sort;
        }
        if (sortDir.value) {
            queryParams["dir"] = sortDir.value;
        } else {
            if (queryParams.dir) queryParams["dir"] = "asc";
        }

        if (filters.length > 0) {
            queryParams["filternames"] = [];
            queryParams["filtervalues"] = [];
            queryParams["filtercond"] = [];
            queryParams["filterfieldtype"] = [];
            queryParams["filtersearchmethod"] = [];
            filters.forEach((filter) => {
                queryParams["filternames"].push(filter[0]);

                let fvalues = filter[1];
                if (typeof fvalues == "string" || typeof fvalues == "number") {
                    queryParams["filtervalues"].push([filter[1]]);
                } else {
                    queryParams["filtervalues"].push(filter[1]);
                }

                if (filter[2]) {
                    queryParams["filtersearchmethod"].push(filter[2]);
                } else {
                    queryParams["filtersearchmethod"].push("normal");
                }

                if (filter[3]) {
                    queryParams["filterfieldtype"].push(filter[3]);
                } else {
                    queryParams["filterfieldtype"].push("string");
                }
                if (filter[4]) {
                    queryParams["filtercond"].push(filter[4]);
                } else {
                    queryParams["filtercond"].push("and");
                }
            });
        } else {
            if (queryParams.filternames) {
                delete queryParams.filternames;
            }
            if (queryParams.filtervalues) {
                delete queryParams.filtervalues;
            }
        }
        return queryParams;
    };

    return {
        generate,
    };
}
